// Generated by purs version 0.15.7
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_String_Regex_Unsafe from "../Data.String.Regex.Unsafe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var Ok = /* #__PURE__ */ (function () {
    function Ok(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Ok.create = function (value0) {
        return function (value1) {
            return new Ok(value0, value1);
        };
    };
    return Ok;
})();
var Err = /* #__PURE__ */ (function () {
    function Err(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Err.create = function (value0) {
        return function (value1) {
            return new Err(value0, value1);
        };
    };
    return Err;
})();
var Parser = function (x) {
    return x;
};
var runParser = function (v) {
    return function (s) {
        return v.runParser(s);
    };
};
var resShow = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        show: function (v) {
            if (v instanceof Ok) {
                return "Ok(" + (show(v.value0) + ("," + (v.value1 + ")")));
            };
            if (v instanceof Err) {
                return "Err(" + (v.value0 + ("," + (v.value1 + ")")));
            };
            throw new Error("Failed pattern match at Parser (line 17, column 1 - line 19, column 50): " + [ v.constructor.name ]);
        }
    };
};
var resFunctor = {
    map: function (v) {
        return function (v1) {
            if (v1 instanceof Ok) {
                return new Ok(v(v1.value0), v1.value1);
            };
            if (v1 instanceof Err) {
                return new Err(v1.value0, v1.value1);
            };
            throw new Error("Failed pattern match at Parser (line 21, column 1 - line 23, column 34): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var map = /* #__PURE__ */ Data_Functor.map(resFunctor);
var resApply = {
    apply: function (v) {
        return function (v1) {
            if (v instanceof Ok && v1 instanceof Ok) {
                return new Ok(v.value0(v1.value0), v1.value1);
            };
            if (v instanceof Err) {
                return new Err(v.value0, v.value1);
            };
            if (v1 instanceof Err) {
                return new Err(v1.value0, v1.value1);
            };
            throw new Error("Failed pattern match at Parser (line 25, column 1 - line 28, column 30): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Functor0: function () {
        return resFunctor;
    }
};
var apply = /* #__PURE__ */ Control_Apply.apply(resApply);
var resBind = {
    bind: function (v) {
        return function (v1) {
            if (v instanceof Ok) {
                return v1(v.value0);
            };
            if (v instanceof Err) {
                return new Err(v.value0, v.value1);
            };
            throw new Error("Failed pattern match at Parser (line 30, column 1 - line 32, column 35): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Apply0: function () {
        return resApply;
    }
};
var repeat = function (v) {
    return {
        runParser: function (s) {
            var res = v.runParser(s);
            if (res instanceof Err) {
                return new Ok([  ], s);
            };
            if (res instanceof Ok) {
                var rest = repeat(v);
                return apply(map(Data_Array.cons)(res))(runParser(rest)(res.value1));
            };
            throw new Error("Failed pattern match at Parser (line 87, column 13 - line 91, column 41): " + [ res.constructor.name ]);
        }
    };
};
var re = function (rs) {
    var pattern = Data_String_Regex_Unsafe.unsafeRegex("^" + rs)(Data_String_Regex_Flags.noFlags);
    return {
        runParser: function (s) {
            var v = bind(Data_String_Regex.match(pattern)(s))(function (a) {
                return join(Data_Array.index(Data_Array_NonEmpty.toArray(a))(0));
            });
            if (v instanceof Data_Maybe.Just) {
                return new Ok(v.value0, Data_String_CodePoints.drop(Data_String_CodePoints.length(v.value0))(s));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return new Err("Failed to parse", s);
            };
            throw new Error("Failed pattern match at Parser (line 116, column 17 - line 118, column 47): " + [ v.constructor.name ]);
        }
    };
};
var parserFunctor = {
    map: function (f) {
        return function (v) {
            return {
                runParser: function (s) {
                    return map(f)(v.runParser(s));
                }
            };
        };
    }
};
var parserApply = {
    apply: function (v) {
        return function (v1) {
            return {
                runParser: function (s) {
                    var v2 = v.runParser(s);
                    if (v2 instanceof Err) {
                        return new Err(v2.value0, v2.value1);
                    };
                    if (v2 instanceof Ok) {
                        var v3 = v1.runParser(v2.value1);
                        if (v3 instanceof Err) {
                            return new Err(v3.value0, v3.value1);
                        };
                        if (v3 instanceof Ok) {
                            return new Ok(v2.value0(v3.value0), v3.value1);
                        };
                        throw new Error("Failed pattern match at Parser (line 71, column 26 - line 73, column 41): " + [ v3.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Parser (line 69, column 17 - line 73, column 41): " + [ v2.constructor.name ]);
                }
            };
        };
    },
    Functor0: function () {
        return parserFunctor;
    }
};
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(parserApply);
var sepBy = function (v) {
    return function (v1) {
        return {
            runParser: function (s) {
                var res = v1.runParser(s);
                if (res instanceof Err) {
                    return new Ok([  ], s);
                };
                if (res instanceof Ok) {
                    var rest = repeat(applySecond(v)(v1));
                    return apply(map(Data_Array.cons)(res))(runParser(rest)(res.value1));
                };
                throw new Error("Failed pattern match at Parser (line 102, column 13 - line 106, column 53): " + [ res.constructor.name ]);
            }
        };
    };
};
var parserApplicative = {
    pure: function (a) {
        return {
            runParser: function (s) {
                return new Ok(a, s);
            }
        };
    },
    Apply0: function () {
        return parserApply;
    }
};
var parserAlternative = {
    alt: function (v) {
        return function (v1) {
            return {
                runParser: function (s) {
                    var v2 = v.runParser(s);
                    if (v2 instanceof Ok) {
                        return new Ok(v2.value0, v2.value1);
                    };
                    if (v2 instanceof Err) {
                        return v1.runParser(s);
                    };
                    throw new Error("Failed pattern match at Parser (line 49, column 17 - line 51, column 39): " + [ v2.constructor.name ]);
                }
            };
        };
    },
    Functor0: function () {
        return parserFunctor;
    }
};
var noop = {
    runParser: function (s) {
        return new Err("", s);
    }
};
var altLazy = function (v) {
    return function (thunk) {
        return {
            runParser: function (s) {
                var v1 = v.runParser(s);
                if (v1 instanceof Ok) {
                    return new Ok(v1.value0, v1.value1);
                };
                if (v1 instanceof Err) {
                    return runParser(thunk(Data_Unit.unit))(s);
                };
                throw new Error("Failed pattern match at Parser (line 58, column 15 - line 60, column 48): " + [ v1.constructor.name ]);
            }
        };
    };
};
export {
    Ok,
    Err,
    Parser,
    noop,
    altLazy,
    runParser,
    repeat,
    sepBy,
    re,
    resShow,
    resFunctor,
    resApply,
    resBind,
    parserFunctor,
    parserApplicative,
    parserAlternative,
    parserApply
};
